export class OrderFormUtils {
    
  static getPriceFormat(price: number, symbol: string) {
    return `${symbol} ${(Math.round(price * 100) / 100).toFixed(2)}`;
  }

  // static getCurrecy(paymentType: PaymentType, source: string) {
  //   switch (paymentType.currency) {
  //     case 'EUR':
  //       return '€';
  //     case 'USD':
  //       return '$';
  //     case 'PLANETS':
  //     case 'ALGO':
  //       if (source.indexOf('planetwatch.us') > -1) {
  //         return '$';
  //       } else {
  //         return '€';
  //       }
  //   }
  //   return paymentType.currency;
  // }

  static getCurrecy(currency: string) {
    switch (currency) {
      case 'EUR':
        return '€';
      case 'USD':
        return '$';
    }
    return '';
  }

}

export const VATs = [
  { country: 'Germany', percentage: 19 },
  { country: 'Spain', percentage: 21 },
  { country: 'Netherlands', percentage: 21 },
  { country: 'Slovenia', percentage: 22 },
  { country: 'Poland', percentage: 23 },
  { country: 'Belgium', percentage: 21 },
  { country: 'Bulgaria', percentage: 20 },
  { country: 'Sweden', percentage: 25 },
  { country: 'Austria', percentage: 20 },
  { country: 'Romania', percentage: 19 },
  { country: 'Denmark', percentage: 25 },
  { country: 'Cyprus', percentage: 19 },
  { country: 'France', percentage: 20 },
  { country: 'Portugal', percentage: 23 },
  { country: 'Slovakia', percentage: 20 },
  { country: 'Ireland', percentage: 23 },
  { country: 'Greece', percentage: 24 },
  { country: 'Latvia', percentage: 21 },
  { country: 'Estonia', percentage: 20 },
  { country: 'Luxembourg', percentage: 17 },
  { country: 'Hungary', percentage: 27 },
  { country: 'Czech Republic', percentage: 21 },
  { country: 'Finland', percentage: 24 },
  { country: 'Malta', percentage: 18 },
  { country: 'Croatia', percentage: 25 },
  { country: 'Italy', percentage: 22 },
  { country: 'Lithuania', percentage: 21 }
  //{ country: 'Other', percentage: 0 }
];